import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-selection",
  "aria-label": "Выбранный интервал"
}
const _hoisted_2 = { class: "w-selection-head" }
const _hoisted_3 = { class: "w-small" }
const _hoisted_4 = {
  key: 0,
  class: "w-actions"
}
const _hoisted_5 = { class: "w-small" }
const _hoisted_6 = {
  key: 0,
  class: "w-error"
}
const _hoisted_7 = { class: "w-small" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "w-actions"
}
const _hoisted_10 = {
  key: 2,
  class: "w-selection-fields"
}
const _hoisted_11 = { class: "w-field" }
const _hoisted_12 = { class: "w-field" }
const _hoisted_13 = { class: "w-field" }
const _hoisted_14 = { class: "w-field" }
const _hoisted_15 = { class: "w-field" }
const _hoisted_16 = ["value"]
const _hoisted_17 = ["disabled"]

import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import { durationMinutes, formatDate } from '~utils/calendarModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'SlotSelection',
  setup(__props) {

const store = useScheduleStore();

const slot = computed(() => store.selectedSlot);
const rest = computed(() => store.selectedBreak);
const range = computed(() => (store.selection?.kind === 'range' ? store.selection : null));

// Выделенный приём/перерыв мог исчезнуть после обновления — тогда панель не нужна
const visible = computed(() => !!(slot.value || rest.value || range.value));

const title = computed(() => {
  const { selection } = store;
  if (!selection) return '';
  const day = formatDate(selection.date, { weekday: 'short', day: 'numeric', month: 'long' });
  return `${day} · ${selection.start}–${selection.end}`;
});

const appointment = computed(() => (
  slot.value && store.schedule.appointments.find((item) => item.slotId === slot.value?.id)
));

const patientName = computed(() => {
  const patient = appointment.value?.patient;
  if (patient && typeof patient === 'object') return patient.name || `Пациент №${patient.id}`;
  return patient || `Пациент №${appointment.value?.patientId}`;
});

const availability = computed(() => slot.value && store.slotAvailability(slot.value));

const blockedReason = computed(() => {
  if (availability.value?.branchBlocked) return availability.value.branchReason;
  if (availability.value?.color === 'gray') return 'В этом интервале кабинет закрыт на перерыв.';
  return 'В этом интервале есть пациент другого врача.';
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (visible.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(title.value), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(store).staffDoctor?.name), 1)
          ]),
          _createElementVNode("button", {
            class: "w-button",
            type: "button",
            "aria-label": "Закрыть выделение",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).clearSelection()))
          }, [
            _createVNode(_component_q_icon, { name: "close" })
          ])
        ]),
        (slot.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, " Кабинет " + _toDisplayString(_unref(store).roomNumber(slot.value.roomId)) + " · " + _toDisplayString(_unref(durationMinutes)(slot.value)) + " мин. ", 1),
              (appointment.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", null, _toDisplayString(patientName.value), 1),
                    (_unref(store).canEdit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "w-button danger",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).cancelAppointment(appointment.value.id)))
                        }, " Отменить запись "))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (availability.value?.blocked)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(blockedReason.value), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(store).patientId
              ? `Пациент №${_unref(store).patientId}`
              : 'Выберите пациента на основной странице'), 1),
                          (_unref(store).canEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "w-button primary",
                                type: "button",
                                disabled: !_unref(store).patientId,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).book(slot.value.id)))
                              }, " Записать пациента ", 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ], 64)),
                    (_unref(store).canEdit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "w-button",
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).removeSlot(slot.value.id)))
                        }, " Убрать приём "))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : (rest.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(rest.value.label), 1),
                (_unref(store).canEdit)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "w-button",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).removeBreak(rest.value.id)))
                    }, " Убрать перерыв "))
                  : _createCommentVNode("", true)
              ]))
            : (range.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _cache[11] || (_cache[11] = _createTextVNode(" Дата ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((range.value.date) = $event)),
                      type: "date"
                    }, null, 512), [
                      [
                        _vModelText,
                        range.value.date,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_12, [
                    _cache[12] || (_cache[12] = _createTextVNode(" С ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((range.value.start) = $event)),
                      type: "time"
                    }, null, 512), [
                      [
                        _vModelText,
                        range.value.start,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _cache[13] || (_cache[13] = _createTextVNode(" До ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((range.value.end) = $event)),
                      type: "time"
                    }, null, 512), [
                      [
                        _vModelText,
                        range.value.end,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_14, [
                    _cache[14] || (_cache[14] = _createTextVNode(" Длительность, мин ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((range.value.duration) = $event)),
                      type: "number",
                      min: "1",
                      max: "480",
                      step: "1"
                    }, null, 512), [
                      [
                        _vModelText,
                        range.value.duration,
                        void 0,
                        {
                          lazy: true,
                          number: true
                        }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_15, [
                    _cache[15] || (_cache[15] = _createTextVNode(" Кабинет ", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((range.value.roomId) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).allowedRooms, (room) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: room.id,
                          value: room.id
                        }, _toDisplayString(room.number ?? room.id) + " · " + _toDisplayString(room.purpose), 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [
                        _vModelSelect,
                        range.value.roomId,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "w-button primary",
                    type: "button",
                    disabled: !_unref(store).canEdit,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(store).addRange()))
                  }, " Добавить приём ", 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})